import RightRuler from "../components/RightRuler";

function RightStack({ className = "" }) {
  return (
    <aside className={`${className} pt-12 pb-8 xl:pt-36 right-0 h-full flex-col justify-center hidden lg:flex`}>
      <div className="flex items-center justify-center">
        <RightRuler />
      </div>
    </aside>
  );
}

export default RightStack;